import React, {useEffect, useState} from 'react';
import { useSelector } from "react-redux";
import ReactECharts from 'echarts-for-react';
import styled , { css }  from "styled-components";
import { RootState } from "../store";
import { useShallowEqualSelector } from "../modules/hooks"
import ReactDOMServer from 'react-dom/server';

const HiddenDiv = styled.div`
position: absolute;
top: -20px;
background-color: black;
color: white;
height: 180px;
width: 170px;
opacity: 0.8;
`;

const HiddenDivName = styled.div`
  display: flex;
  line-height: normal;
  font-size: 18px;
  margin: 16px 0 10px 16px;
  `;

const HiddenDivInfo = styled.div`
  display: flex;
  padding: 0 16px;
  font-family: Arial,Helvetica Neue,Helvetica,sans-serif;
  `;

const HiddenDivText = styled.div`
  line-height: normal;
  font-size: 14px;
  opacity: 0.9;
  `;

const HiddenDivShowTimes = styled.div`
  width:100px;
  text-align:start;
  `;

const HiddenDivNumber = styled.div`
  text-align: start;
  line-height: normal;
  font-size: 30px;
  font-weight: bold;
  letter-spacing: 3px;
  margin-top: 4px;
  `;

const HiddenDivRank = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  
  padding-left: 5px;
  border-left: 1px dashed white;
  `;


const Top1to3 = styled.div`
  background-image: url("${process.env.PUBLIC_URL}/images/04-yellow-frag.png");
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  line-height: 0;
  color: white;
  width: 18px;
  height: 22px;
  font-size: 15px;
`;

const Top3to10 = styled.div`
  background-color: #c6c8c5;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 0;
  width: 20px;
  height: 20px;
  font-size: 11px;
`;

const Rank= styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
`;

const RankContainer = styled.div`
${(props) => {

    if (props.theme.isMobile || props.theme.isTablet) {
      return css`
      padding-right: 0;
      `;
    }
    else
    {
      return css`
      padding-right:10px;
      `;
    }
  }}
  
`;

const Container = styled.div`
  display: flex;
`;

const Part1DataChart : React.FC<any> = () => {
    const isMobile: any = useSelector((state: RootState) => state.storeSlice.isMobile);
    const isTablet: any = useSelector((state: RootState) => state.storeSlice.isTablet);
    const generalInfo: any = useShallowEqualSelector((state: RootState) => state.storeSlice.generalInfo);
    const Symbol = 'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEkAAAA4CAYAAACxDdW4AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAATsSURBVHhe7ZpNaBtHFMfnza7ilEJl3xwcGkN9KRSq3HooqXtOob4VSiEm7aHBDcgH22pxQCUmUaxDBK5pDwl1jz2UGnouTUJ7rm+l0BQHYvBNVi8O0Wqn742e3FrS7o72Q5uF/YGY91ZIs/vfN29m5y2ICMx8sf0BSPccu8K2nR/3q8tP2E2NZr0yL4VbEq6c1Aeke+QKuTe1Unug/REZWaTz61tlAbCmlJjmQ/04INRvKNiVcQrWvF2ZlbaoCqUW0C12jw7Qws+O24HG1Oe1/e6hYIxFoqjBO/IN/qR7d4JRKNajpxvX59lPjFZ9tYy9VdH0EqefFggov7Ja22HfFyORZm5s38M7dBXNEMNTHRVsp5RUVLXqlR08tyvsjgbAd8WV2iJ7nkhuPTm3vnUbT+JjNEPmL5hsO4U/2ImV1uZaI7RABP62dadCEeiL74VPV79+23I6j9AMKdD/gb2DjaWL7ERGJ2elfmE3Ei7Au35J3TeSLMf5CZsYBCJUSSf9mJBKGOUTE0BhwvfBUySdqM2TtBk4K7IViX/urOIMpi6wGxmcYN6hyGR3AO9IkqLCVmzQsoGGMLuhUVLSNB8rOHQ9/9NnuKk32IgVq+MGziZB4J0vsRkbSoDnf/rlJJvbWAHlzrEZGozIN9mMDRpybA7gm7iTAO/YeTYzw9hFAhAvs5kZxi4SjpU/2coMfiI53MaKAvkXm5nBT6REnrU6loxtETguPEXCbP8VmzGijg6r135lJzN4ivR043qDLordWMDnmy/ZzBT+iduVn7IVGZzVDrvCZw9fkQ5uLX2PV3ef3Sgc21b7LbYzh38kIQc3lz6JKNRxwW6//iLsfYclUCSChMJEvozmqMuCx1kXiDASiaB8ghc8h88Vu+gGifWYRD3Y+Gwu6wIRI2+o6d1KepJX6pIS4lX8A4u/Qlccozi/Y7ubZJL22nIFUNMKxCye07RSp/fC8LsjPMFDUGIfvzvkw6cortWG/y+3gXAx4EM0X+oeCYRE+7tjW4tJro2ad8uT8vnZMl7JInZpuBEHT/DsdtwzzxpTy43AZU6gSLTlik/udTQjbJ3AXsF+vhD30NMRBYq2hE1LSf208PfV4sqmb9T7ijSzvo1DJ7YNLke48JFeVkSEosdyJh7Eta+EQfBQFZ4teEXVUJFmq3cvcBnIdGiZg8sJvawISXNzpSSFpMpG2OjxouUKd35qtb7H/gkDIiUqUI+QQiUoUI+W24FSfwl8YAmAAv2MTXICEUpd7VZjzNFDDPQOQlICEUXLVrvUF/uaUyLpaq0Qr3W9RAEh1bdsGyHbE9Uk9rb7oT6oL3Y1J8ONhxltiCVSABgGrqkemrxQEWe11hTMTxd7+ekkktrtAk2DYxOIwFnlEt0cdj0JqrAmAea+kz7/G24g3mNrnEC7c+YG20Oh944w4jzLPQnyPvVNhhaJk+hYo6gHCnCZzaFISSvpdJC2q6u6WiSQ7jVq04BK32wOBZ/FEn8JzAuluuV0LRI+ZCU+a/jh97ZJSkNN0+ubcxJMdNt0UCCHvnfQywlpoh+g2U528RiA5/sBtkhdJOGcxVV+TiC5SAbkIhmQi2RALpIBuUgG5CIZkItkQC6SAblIBuQiGZCLZEAukgG5SAbkIhmQi2SArrvNrG81tZcWIH8YVvamsjYIK9WXUZXolP8F8JWbdC/dD40AAAAASUVORK5CYII=';

    const [options, setOptions] = useState<any>(null);

    useEffect(() => {
      if(generalInfo){
          const lastNameArray = generalInfo.topFamilyName.map((m: any) => m.name);
          const valueIntArray = generalInfo.topFamilyName.map((m: any) => m.count);
          const percentageArray = generalInfo.topFamilyName.map((m: any) => m.percent.toFixed(2)+'%');
          setOptions({
              textStyle: {
                  fontFamily: 'Arial',
              },
              legend: {
                  show: false
              },
              tooltip: {
                  trigger: 'axis',
                  transitionDuration :0.1,
                  backgroundColor: "rgba(255,255,255,0)",
                  borderColor :'#FFF',
                  borderWidth:0,
                  padding: 0,
                  borderRadius:0,
                  //textStyle: {
                  //    color: "#FFF",
                  //    fontSize : 16,
                  //},
                  axisPointer: {
                      type: 'shadow'
                  },
                  //formatter: '{b} : {c}人',
                  formatter: function (params: any) {
                      const htmlString = ReactDOMServer.renderToStaticMarkup(
                          <HiddenDiv>
                              <HiddenDivName>{params[0].axisValue}</HiddenDivName>
                              <HiddenDivInfo>
                                  <HiddenDivShowTimes>
                                      <HiddenDivText>姓氏人數</HiddenDivText>
                                      <HiddenDivNumber>{params[0].value}</HiddenDivNumber>
                                      <HiddenDivText>全澳佔比</HiddenDivText>
                                      <HiddenDivNumber>{percentageArray[params[0].dataIndex]}</HiddenDivNumber>
                                  </HiddenDivShowTimes>
                                  <HiddenDivRank>
                                      <HiddenDivText>排名</HiddenDivText>
                                      <HiddenDivNumber>{params[0].dataIndex + 1}</HiddenDivNumber>
                                  </HiddenDivRank>
                              </HiddenDivInfo>
                          </HiddenDiv>
                      );

                      return htmlString
                      //(
                      // params[0].axisValue
                      //+'<br/>排名：'+ (params[0].dataIndex+1)
                      // +'<br/>姓氏人數：'+String(params[0].value).replace(/\B(?=(\d{3})+(?!\d))/g, ',') +'人' 
                      //+'<br/>全澳佔比：'+ percentageArray[params[0].dataIndex]
                      //+
                      // )
                  },
              },
              grid: {
                  containLabel: true,
                  top:0,
                  bottom:0,
                  left: (isMobile || isTablet) ? 15 : 20 ,
                  right:-60
              },
              yAxis: [
                  {
                      type: 'category',
                      data:  lastNameArray ,
                      inverse: true,
                      axisLine: { show: false },
                      axisTick: { show: false },
                      axisLabel: {
                          margin: (isMobile || isTablet) ? 15 : 30 ,//30, //20 
                          fontSize: 22,
                          fontWeight:'bold',
                          color: '#106b64'
                      },
                      axisPointer: {
                          label: {
                              show: false,
                              margin: 30
                          }
                      }
                  }
                  ,
                  {
                      type: 'category',
                      data: valueIntArray,
                      inverse: true,
                      axisLine: { show: false },
                      axisTick: { show: false },
                      axisLabel: {
                          margin: 0,
                          fontSize: 22,
                          color: '#106b64',
                          formatter: function (value: any) {
                              return String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ',') +'{SmallSize|人}'
                          },
                          rich: {
                              SmallSize: {
                                  verticalAlign:'bottom',
                                  fontSize: 16
                              }
                          }
                      },
                  }
                  ,
                  {
                      type: 'category',
                      data:  percentageArray,
                      inverse: true,
                      axisLine: { show: false },
                      axisTick: { show: false },
                      axisLabel: {
                          backgroundColor:'#106b64',
                          padding: [4, 10, 4, 10],
                          borderRadius:10,
                          margin: (isMobile || isTablet) ? 90 : 100 ,
                          fontSize: 15,
                          color: '#FFF'
                      }
                  }
              ],
              xAxis: {
                  type: 'value',
                  splitLine: { show: false },
                  axisLabel: { show: false },
                  axisTick: { show: false },
                  axisLine: { show: false }
              },
              series: [
                  {
                      name: '',
                      type: 'pictorialBar',
                      barWidth: (isMobile || isTablet) ? 35 : 40 ,
                      label:{
                          color: '#666666',
                          show: false,
                          position: 'right',
                          offset: [10, 0],
                          fontSize: 22,
                          formatter: '{c}人',
                      },
                      symbol: Symbol,
                      symbolRepeat: true,
                      symbolMargin: (isMobile || isTablet) ? '5%' : '6%' ,
                      symbolSize: ['65%', '50%'],
                      barCategoryGap: 40,
                      data: valueIntArray
                  }
              ]
          });
      }
    }, [generalInfo]);

    return (
        <>
            {options && <Container>
                <RankContainer>
                    <Rank><Top1to3>1</Top1to3></Rank>
                    <Rank><Top1to3>2</Top1to3></Rank>
                    <Rank><Top1to3>3</Top1to3></Rank>
                    <Rank><Top3to10>4</Top3to10></Rank>
                    <Rank><Top3to10>5</Top3to10></Rank>
                    <Rank><Top3to10>6</Top3to10></Rank>
                    <Rank><Top3to10>7</Top3to10></Rank>
                    <Rank><Top3to10>8</Top3to10></Rank>
                    <Rank><Top3to10>9</Top3to10></Rank>
                    <Rank><Top3to10>10</Top3to10></Rank>
                </RankContainer>
                <ReactECharts option={options} style={{width: '100%', height: '400px'}}/>
            </Container>}
        </>
    );
}

export default Part1DataChart;
